/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchBillResultItem } from './BatchBillResultItem';
import {
    BatchBillResultItemFromJSON,
    BatchBillResultItemFromJSONTyped,
    BatchBillResultItemToJSON,
    BatchBillResultItemToJSONTyped,
} from './BatchBillResultItem';

/**
 * 
 * @export
 * @interface BatchBillCreateRespVo
 */
export interface BatchBillCreateRespVo {
    /**
     * 每个订单的创建结果列表
     * @type {Array<BatchBillResultItem>}
     * @memberof BatchBillCreateRespVo
     */
    results?: Array<BatchBillResultItem>;
}

/**
 * Check if a given object implements the BatchBillCreateRespVo interface.
 */
export function instanceOfBatchBillCreateRespVo(value: object): value is BatchBillCreateRespVo {
    return true;
}

export function BatchBillCreateRespVoFromJSON(json: any): BatchBillCreateRespVo {
    return BatchBillCreateRespVoFromJSONTyped(json, false);
}

export function BatchBillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchBillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(BatchBillResultItemFromJSON)),
    };
}

export function BatchBillCreateRespVoToJSON(json: any): BatchBillCreateRespVo {
    return BatchBillCreateRespVoToJSONTyped(json, false);
}

export function BatchBillCreateRespVoToJSONTyped(value?: BatchBillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(BatchBillResultItemToJSON)),
    };
}

